<template>
  <div id="app" :class="[wrap]" :style="{ paddingBottom: $route.meta.hideFooter ? 0 : '327px'}">
    <common-notification></common-notification>
    <visa-header :msgCount="msgCount"></visa-header>
    <fixed-right-service v-if="$route.name!='login' && $route.name!='forget' && $route.name!='videoDetail'"></fixed-right-service>
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <visa-footer v-show="!$route.meta.hideFooter" :customer_service="customer_service"></visa-footer>
    <follow-modal></follow-modal>
    <login-box></login-box>
    <!--  签问对话框 -->
    <chatvisa-frame
      v-if="showChatVisaFrame"
    ></chatvisa-frame>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import {
  SAVE_MP_WATCH,
  INIT_QRCODE_STA,
  IS_LOGIN,
  IS_SHOW_MODAL,
} from '@/store/modules/follow-official-accounts/follow-official-accounts-types';
import {
  SET_PEER_DATA,
} from '@/store/modules/user/user-mutation-types';

import utils from './libs/utils';
import Http from './libs/http';
import User from './libs/user';
import VisaHeader from './components/common/header';
import VisaFooter from './components/common/footer';
import FollowModal from './components/common/follow-official-accounts-modal';
import fixedRightService from './components/fixed-right-service/fixed-right-service';
import { env } from './libs/env';
import './libs/maps';
import './libs/add-prototype-methods';
import './libs/directives';
import LoginBox from './components/common/login/login-box';
import CommonNotification from './components/common-notification.vue';
import chatvisaFrame from './pages/chat-visa/component-external/chatvisa-frame.vue';

User.init();

export default {
  name: 'ssq',
  components: {
    VisaHeader,
    VisaFooter,
    FollowModal,
    LoginBox,
    CommonNotification,
    chatvisaFrame,
    fixedRightService,
  },
  data() {
    return {
      User,
      bindModal: true,
      msgCount: 0,
      floatVisible: false,
      countryId: 0,
    };
  },
  computed: {
    ...mapState('config', [
      'customer_service',
    ]),
    ...mapState('chatVisa', [
      'showChatVisaFrame',
    ]),
    wrap() {
      return this.$route.matched[0] ? (`${this.$route.matched[0].name}-wrap`) : '';
    },
    appHeight() {
      return `${document.documentElement.clientHeight}px`;
    },
  },
  watch: {
    $route(to) {
      // 切换关注公众号弹窗的状态
      this.IS_SHOW_MODAL({ name: to.name });

      // window.scrollTo(0, 0);

      if (window.ga) {
        ga('set', 'page', to.name);
        ga('send', 'pageview');
      }

      if (window.MtaH5 && !env) {
        MtaH5.pgv();
      }
    },
  },
  methods: {
    ...mapActions('config', [
      'getSysConfig',
    ]),
    ...mapActions('user', [
      'getIPLocation',
    ]),

    ...mapMutations('followOA', [
      SAVE_MP_WATCH,
      INIT_QRCODE_STA,
      IS_LOGIN,
      IS_SHOW_MODAL,
    ]),

    ...mapMutations('user', [
      SET_PEER_DATA,
    ]),


    goTop() {
      const st = document.body.scrollTop || document.documentElement.scrollTop;
      const time = st * 0.2 + 200;

      function esae(t) {
        return (t * 2) < 1 ?
          4 * t * t * t :
          (4 * (t - 1) * (t - 1) * (t - 1) + 1);
      }

      let start;
      function animate(timestamp) {
        if (!start) start = timestamp;

        const ds = timestamp - start;

        const dp = ds / time;
        scrollTo(0, st - st * esae(dp));

        if (ds < time) {
          requestAnimationFrame(animate);
        } else {
          scrollTo(0, 0);
        }
      }

      requestAnimationFrame(animate);
    },
    getStats() {
      if (User.isLogin() && !User.isSignOut) {
        Http.post('/peer_notice_message_unread_count_query', {}, { noToast: true }).then((data) => {
          this.msgCount = data.total_count;
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },
    getLogin() {
      User.initUserDetail();
      if (User.isLogin()) {
        this.getStats();
        setInterval(this.getStats, 30000);
      }
    },
    createGa() {
      if (window.ga) {
        gtag('config', 'UA-108398817-1');
        ga('create', 'UA-108398817-1', 'auto');
        ga('require', 'ec');
        ga('set', 'userId', User.isLogin() ? User.peer_account_id : utils.ranString(8));
        ga('set', 'page', this.$route.name);
      }

      if (window.MtaH5 && !env) {
        MtaH5.pgv();
      }
    },

    // 处理老的hash路由问题
    handleOldHashRoute() {
      const path = this.$route.path;
      const hashPath = window.location.hash.split('#')[1];
      if (path === '/' && hashPath) {
        window.location.replace(`${window.location.origin}${hashPath}`);
      }
    },
  },
  mounted() {
    if (navigator.platform.indexOf('Mac') > -1) {
      document.body.classList.add('mac');
    }
  },
  created() {
    this.handleOldHashRoute();
    User.inject(this);
    this.getLogin();
    this.getSysConfig();
    this.getIPLocation();
    this.createGa();
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
};
</script>

<style lang="less">
@import (inline) '../theme/index.css';
@import './assets/less/common.less';
@import './assets/less/map.less';
@import './assets/less/public.less';
@import "./assets/less/base.less";
@import './assets/less/github-markdown-light.less';

#app{
  min-width: 1250px;
  position:relative;
  padding-bottom:327px;
  min-height: 100vh;

  &::before{
    content:"";
    display:block;
    height:68px;
    width:100%;
  }
}
textarea {
  resize: none !important;
}

.fill-remaining-space {
  flex: 1 1 auto;
}

// 商品详情页 tabs 样式。由于 scope 影响，样式只有放在这里才生效
.question-el-tabs {
  .el-tabs__header {
    margin-bottom: 10px;
    .el-tabs__item {
      font-size: 16px;
      color: #777777;
    }
    .el-tabs__item.is-active {
      color: #5e9be1;
    }
  }
}

input::-webkit-input-placeholder {
  color: #91999F;
}
input:-moz-placeholder {/* Firefox 18- */
  color: #91999F;
}
input::-moz-placeholder{/* Firefox 19+ */
  color: #91999F;
}
input:-ms-input-placeholder {
  color: #91999F;
}

</style>



// WEBPACK FOOTER //
// src/App.vue